import React from 'react'
import { Stack, Table, TableBody, Grid, TableCell, TableContainer, TableHead, TableRow, Box, Button, Tooltip, Paper } from '@mui/material'
import moment from 'moment/moment'
import { useSelector } from 'react-redux'
import { getWithOtherChargesColumn } from '../Constant'

const WithOtherCharges = ({tableData,loginData,reportType,showSummaryReport,detailedFilter,selFromBranch,selDestCity,selBranch,toDate,fromDate,selVehicle,selPaymentTpe}) => {
    const companySettings = useSelector((state) => state?.common?.companySettings)
    const loginCountryId = companySettings[0]?.DefaultCurrencyID;
    const UseToPayAsCOD=companySettings[0]?.UseToPayAsCOD
    const withOtherChargesColumn=getWithOtherChargesColumn(UseToPayAsCOD)
    const InsideRowContent = ({ item, index, fontVal }) => {
        return (
            <>
                <TableRow >
                    {item.isTotal === true ? (
                        <>
                            <TableCell
                                className="reportTD"
                                colSpan={6}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.srNo}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.TotalUnits}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.PaidFreight}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.TopayFreight}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.DDDVFreight}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.PaidOther}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal,fontWeight: '700',backgroundColor: '#EEE',textAlign: 'right', color: '#444',}}
                            >
                                {item.TopayOther}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.DDDVOther}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.PaidGST}
                            </TableCell>
                            <TableCell className="reportTD" colSpan={1} style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', color: '#444', textAlign: 'right' }}>
                                {item.TopayGST}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.DDDVGST}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.TotalPaid}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{
                                    fontSize: fontVal,
                                    fontWeight: '700',
                                    backgroundColor: '#EEE',
                                    textAlign: 'right', color: '#444',
                                }}
                            >
                                {item.TotalToPay}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.TotalToPayDDDV}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ fontSize: fontVal, fontWeight: '700', backgroundColor: '#EEE', textAlign: 'right', color: '#444' }}
                            >
                                {item.NetAmount}
                            </TableCell>
                        </>
                    ) : (
                        <>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'left' }}
                            >
                                {item.srNo}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'left' }}
                            >
                                {item.BusNumber}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'left' }}
                            >
                                {item.ContactNo}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'left' }}
                            >
                                {item.DriverConductorName}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.SealNo}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right', borderRight: '1px solid #aeaeae'  }}
                            >
                                {item.Station}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.TotalUnits}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.PaidFreight}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.TopayFreight}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right', borderRight: '1px solid #aeaeae' }}
                            >
                                {item.DDDVFreight}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.PaidOther}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.TopayOther}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right', borderRight: '1px solid #aeaeae'  }}
                            >
                                {item.DDDVOther}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.PaidGST}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.TopayGST}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right', borderRight: '1px solid #aeaeae' }}
                            >
                                {item.DDDVGST}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.TotalPaid}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.TotalToPay}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.TotalToPayDDDV}
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                colSpan={1}
                                style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', verticalAlign: 'top', textAlign: 'right' }}
                            >
                                {item.NetAmount}
                            </TableCell>
                        </>
                    )}
                </TableRow>
            </>
        )
    }
    return (
        <>
            <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
                <TableContainer className="scrollBlue" sx={{
                    '&::-webkit-scrollbar': { width: '6px', height: '6px' }, border: '1px solid #aeaeae', '& .MuiTableCell-root': {
                        fontSize: '14px !important'
                    }
                }} component={Paper}>
                    <Table id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
                        <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                            <TableRow>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '18px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={10}
                                >
                                    <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '18px', fontWeight: '500', textAlign: 'right' }}
                                    colSpan={10}
                                >
                                    <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={20}></TableCell>
                            </TableRow>
                            <TableRow style={{ color: 'white' }}>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    From Dispatch Date
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    To Dispatch Date
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    dispatch By Branch
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Destination City
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    DestinationBranch
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Vehicle Number
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Payment Type
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Report Type
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Report View
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Report Option
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{selDestCity?.name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{selBranch?.name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{selVehicle?.name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{selPaymentTpe?.name || 'All'}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{reportType?.Name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{showSummaryReport?.Name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{detailedFilter?.Name} </span>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={20}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableHead style={{ position: 'sticky', top: '0' }}>
                            <TableRow >
                                <TableCell
                                    className="reportTD"
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '700',
                                        textAlign: 'left',
                                        color: '#444',
                                        height: '36px',
                                        backgroundColor: '#bfe1ff'
                                    }}
                                    colSpan={6}
                                >
                                    Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '700',
                                        textAlign: 'left',
                                        color: '#444',
                                        height: '36px',
                                        backgroundColor: '#bfe1ff'
                                    }}
                                    colSpan={7}
                                >
                                    Destination City: {selDestCity?.name}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '14px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '700',
                                        textAlign: 'left',
                                        color: '#444',
                                        height: '36px',
                                        backgroundColor: '#bfe1ff'
                                    }}
                                    colSpan={7}
                                >
                                    Destination Branch: {selBranch?.name}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                {withOtherChargesColumn.map((col, index) => (
                                    <TableCell
                                        key={`THR-${index}`}
                                        style={{
                                            ...col.headerSx,
                                            fontWeight: 'bold',
                                            fontSize: '14px',
                                            lineheight: '16px',
                                            letterspacing: '0.24px',
                                            fontWeight: '500',
                                            //borderRight: '1px solid #aeaeae' 
                                            borderRight: index === 5 || index === 9 || index === 12 || index === 15? '1px solid #aeaeae': 'none',
                                            // textAlign: index > 9 ? 'right' : 'left',
                                            color: '#444444',
                                            backgroundColor: '#bfe1ff',
                                            position: 'sticky',
                                            // top: '55px',
                                            whiteSpace: 'pre',
                                        }}
                                    >
                                        {col.header}
                                    </TableCell>))}
                            </TableRow>
                        </TableHead>
                        {tableData?.length < 1 ? (
                            <>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={25}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '12px',
                                                }}
                                            >
                                                <span>No results found. Please refine your search parameters and search again.</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </>
                        ) : tableData?.length >= 1 ? (
                            <TableBody
                                className="filter-data-row"
                                style={{ textAlign: 'center', fontSize: '12px', fontWeight: '500', marginLeft: '5px' }}
                            >
                                {tableData?.map((item, index) => (
                                    <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                                ))}
                            </TableBody>
                        ) : (
                            ''
                        )}
                    </Table>
                    {/* <Table style={{ display: "none" }} id="tables" className="table1 table-Report" size="small" aria-label="a dense table">
    <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                            <TableRow>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={12}
                                >
                                    <h3 style={{ paddingLeft: '17px' }}>Report For: Dispatch Report -</h3>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '24px', fontWeight: '500', textAlign: 'right' }}
                                    colSpan={13}
                                >
                                    <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData.strCompanyName}</h3>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={25}></TableCell>
                            </TableRow>
                            <TableRow style={{ color: 'white' }}>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    From Dispatch Date
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={3}
                                >
                                    To Dispatch Date
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={3}
                                >
                                    dispatch By Branch
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={3}
                                >
                                    Destination City
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={3}
                                >
                                    DestinationBranch
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Vehicle Number
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Payment Type
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Report Type
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={2}
                                >
                                    Report View
                                </TableCell>
                                <TableCell
                                    className="ReportItemHead"
                                    style={{
                                        backgroundColor: '#bfe1ff',
                                        color: '#454646',
                                        fontSize: '20px',
                                        fontWeight: 'bold',
                                        textAlign: 'left',
                                    }}
                                    colSpan={3}
                                >
                                    Report Option
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={3}
                                >
                                    <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={3}
                                >
                                    <span>{selFromBranch?.name || loginData?.strBranchName}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={3}
                                >
                                    <span>{selDestCity?.name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={3}
                                >
                                    <span>{selBranch?.name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{selVehicle?.name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{selPaymentTpe?.name || 'All'}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{reportType?.Name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={2}
                                >
                                    <span>{showSummaryReport?.Name}</span>
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                    colSpan={3}
                                >
                                    <span>{detailedFilter?.Name} </span>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell colSpan={25}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableHead style={{ position: 'sticky', top: '0' }}>
                            <TableRow >
                                <TableCell
                                    className="reportTD"
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '20px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '700',
                                        textAlign: 'left',
                                        color: '#444',
                                        height: '36px',
                                        backgroundColor: '#bfe1ff'
                                    }}
                                    colSpan={8}
                                >
                                    Dispatch By Branch: {selFromBranch?.name || loginData?.strBranchName}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '20px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '700',
                                        textAlign: 'left',
                                        color: '#444',
                                        height: '36px',
                                        backgroundColor: '#bfe1ff'
                                    }}
                                    colSpan={8}
                                >
                                    Destination City: {selDestCity?.name}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '20px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '700',
                                        textAlign: 'left',
                                        color: '#444',
                                        height: '36px',
                                        backgroundColor: '#bfe1ff'
                                    }}
                                    colSpan={9}
                                >
                                    Destination Branch: {selBranch?.name}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                {withOtherChargesColumn.map((col, index) => (
                                    <TableCell
                                        key={`THR-${index}`}
                                        style={{
                                            ...col.headerSx,
                                            fontWeight: 'bold',
                                            fontSize: '14px',
                                            lineheight: '16px',
                                            letterspacing: '0.24px',
                                            fontWeight: '500',
                                            // textAlign: index > 9 ? 'right' : 'left',
                                            color: '#444444',
                                            backgroundColor: '#bfe1ff',
                                            position: 'sticky',
                                            top: '55px',
                                            whiteSpace: 'pre',
                                        }}

                                    >
                                        {col.header}
                                    </TableCell>))}
                            </TableRow>
                        </TableHead>
                        {tableData?.length < 1 ? (
                            <>
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={25}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    marginTop: '20px',
                                                    marginBottom: '20px',
                                                    color: 'red',
                                                    fontSize: '20px',
                                                }}
                                            >
                                                <span>No results found. Please refine your search parameters and search again.</span>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </>
                        ) : tableData?.length >= 1 ? (
                            <TableBody
                                className="filter-data-row"
                                style={{ textAlign: 'center', fontSize: '20px', fontWeight: '500', marginLeft: '5px' }}
                            >
                                {tableData?.map((item, index) => (
                                    <InsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                                ))}
                            </TableBody>
                        ) : (
                            ''
                        )}
                    </Table> */}
                </TableContainer>
            </Stack>
        </>
    )
}

export default WithOtherCharges